import { rem } from 'polished';
import { useMediaQuery } from 'usehooks-ts';

import { PC_WIDTH } from '~/constants/screen';

export type ScreenType = 'mobile' | 'pc';

interface ScreenValueOptions<T> {
  mobile: T;
  pc: T;
}

export function useScreenType(): ScreenType {
  const isPc = useMediaQuery(`(min-width: ${rem(PC_WIDTH)})`);

  return isPc ? 'pc' : 'mobile';
}

export function useScreenValue<T>({ mobile, pc }: ScreenValueOptions<T>): T {
  const screenType = useScreenType();

  return { mobile, pc }[screenType];
}
